import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[mbpAutoFocus]',
})
export class AutoFocusDirective implements AfterContentInit {
  @Input() public mbpAutoFocus: boolean;

  public constructor(private el: ElementRef) {}

  public ngAfterContentInit() {
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 0);
  }
}
